<div class="search-input__container">
  <input [(ngModel)]="keyword" (keyup)="keyPressed($event)" [placeholder]="placeholder" class="form-control form-control-sm search-input__text">
  <i (click)="search()" class="fa fa-search search-input__icon format-icon"></i>
  <i *ngIf="keyword.length" (click)="clear()" class="fa fa-times search-input__icon" style="right:0"></i>
</div>
